import type {GetBuildApiArg} from '../../../services/rest'
import {stringifyId} from '../../../types'
import type {BuildId} from '../../../types'

export const getWaitReasonsArg = (buildId: BuildId): GetBuildApiArg => ({
  buildLocator: `id:${stringifyId(buildId)}`,
  fields: 'queuedWaitReasons(property(name,value))',
})
